import React from 'react';
import { FiPhone } from 'react-icons/fi';
import useIsMobile from '../utils/useIsMobile';

const CTA = () => {
  const isMobile = useIsMobile();

  return (
    <section style={{ padding: isMobile ? 'clamp(32px, 6vw, 48px) var(--cc-px) 0' : '0 var(--cc-px) 0', fontFamily: "'DM Sans', 'Segoe UI', sans-serif", position: 'relative', zIndex: 10, marginBottom: -80 }}>
      <div style={{
        margin: '0 auto',
        maxWidth: 'min(100%, var(--content-mid))',
        background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #3b82f6 100%)',
        borderRadius: isMobile ? 20 : 28,
        padding: isMobile ? 'clamp(36px, 8vw, 48px) var(--cc-px)' : 'clamp(48px, 5vw, 72px) clamp(32px, 4vw, 48px)',
        textAlign: 'center',
        boxShadow: '0 24px 72px rgba(37,99,235,0.35)',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* Decorative rings */}
        <div aria-hidden style={{ position: 'absolute', top: -80, right: -80, width: 300, height: 300, borderRadius: '50%', border: '60px solid rgba(255,255,255,0.07)' }} />
        <div aria-hidden style={{ position: 'absolute', bottom: -60, left: -60, width: 240, height: 240, borderRadius: '50%', border: '50px solid rgba(255,255,255,0.05)' }} />
        {/* Dot grid */}
        <div aria-hidden style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)', backgroundSize: '26px 26px' }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <span style={{ fontSize: '0.75rem', fontWeight: 700, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.12em', textTransform: 'uppercase', display: 'block', marginBottom: 14 }}>Ready to Connect?</span>

          <h2 style={{ color: '#fff', fontSize: 'clamp(1.4rem, 3.5vw, 4rem)', fontWeight: 900, margin: '0 0 14px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
            Compare Plans Available at Your Address
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.72)', fontSize: 'clamp(0.9rem, 1.5vw, 1rem)', maxWidth: 520, margin: '0 auto 36px', lineHeight: 1.75 }}>
            As an Authorized Dealer, we help homes and businesses compare Internet and Cable TV plans from licensed providers and complete enrollment. Availability and pricing vary by address and provider.
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'center' }}>
            <a href="tel:+18888802585" style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              background: '#fff', color: '#1e3a8a', fontWeight: 800, fontSize: '1rem',
              padding: '15px 30px', borderRadius: 999, textDecoration: 'none',
              boxShadow: '0 6px 24px rgba(0,0,0,0.2)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 10px 32px rgba(0,0,0,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.2)'; }}
            >
              <FiPhone style={{ width: 18, height: 18 }} />
              +1 (888) 880-2585
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
